import { themeOptions } from "styles/theme";

export const styles = {
    toolTipContent: {
        color: themeOptions.palette.white,
    },
    callout: {
        beak: { background: themeOptions.palette.darkerGrey },
        beakCurtain: { background: themeOptions.palette.darkerGrey },
        calloutMain: {
            background: themeOptions.palette.darkerGrey,
        },
    },
};
